if (navigator.userAgent.toLocaleLowerCase().search('chrome') > -1) {
    document.addEventListener('keydown', function () {
        document.documentElement.classList.remove('mouseFocus');
    });
    document.addEventListener('mousedown', function () {
        document.documentElement.classList.add('mouseFocus');
    });
}
